// Dependencies
import React from 'react'
import { Grid, Typography, makeStyles } from '@material-ui/core'

// Components
import MutualSerNewItem from './MutualSerNewItems'

// mock data
import { mockNews } from '../mock/mockData'

// Css
import 'components/styles/scrollBlueSections.css'

// Styles
const useStyles = makeStyles(() => ({
   container: {
      height: '421px',
      width: '100%',
      padding: '0px 9.5px',
      maxHeight: '723px',
      borderRadius: '4px',
      background: '#ffffff',
      boxShadow: '0px 1px 2px #00000029',
      overflow: 'hidden'
   },
   newsTitleContainer: {
      padding: '14px 0px 10px 9.5px',
      borderBottom: '#00000019 1px solid'
   },
   newsTitle: {
      fontWeight: '600',
      fontSize: '18px',
      color: '#43496a'
   },
   newsContainer: {
      marginTop: '10px',
      padding: '0px 2.5px 12px',
      borderRight: '1px solid #00000019',
      overflow: 'auto',
      height: '342px'
   }
}))

const MutualSerNews = () => {
   const classes = useStyles()
   return (
      <Grid className={classes.container}>
         <Grid className={classes.newsTitleContainer}>
            <Typography className={classes.newsTitle}>
               Noticias Mutual SER EPS
            </Typography>
         </Grid>
         <Grid className={`${classes.newsContainer} blue-scroll-section`}>
            {mockNews.data.map((e, i) => (
               <MutualSerNewItem
                  key={i}
                  description={e.description}
                  imgSrc={e.imgSrc}
                  title={e.title}
                  date={e.date}
                  views={e.views}
               />
            ))}
         </Grid>
      </Grid>
   )
}

export default MutualSerNews
